import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSpecialtiesByWorkspaceIdQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
}>;


export type GetSpecialtiesByWorkspaceIdQuery = { __typename?: 'query_root', specialties: Array<{ __typename?: 'specialties', id: any, parentId?: any | null, name: string, specialtyGroup?: { __typename?: 'specialties', id: any, name: string, parentId?: any | null } | null }> };


export const GetSpecialtiesByWorkspaceIdDocument = gql`
    query getSpecialtiesByWorkspaceId($workspaceId: Int!) {
  specialties(
    where: {workspaces: {workspaceId: {_eq: $workspaceId}}}
    order_by: {name: asc}
  ) {
    id
    parentId
    name
    specialtyGroup {
      id
      name
      parentId
    }
  }
}
    `;

/**
 * __useGetSpecialtiesByWorkspaceIdQuery__
 *
 * To run a query within a React component, call `useGetSpecialtiesByWorkspaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialtiesByWorkspaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialtiesByWorkspaceIdQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetSpecialtiesByWorkspaceIdQuery(baseOptions: Apollo.QueryHookOptions<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables> & ({ variables: GetSpecialtiesByWorkspaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables>(GetSpecialtiesByWorkspaceIdDocument, options);
      }
export function useGetSpecialtiesByWorkspaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables>(GetSpecialtiesByWorkspaceIdDocument, options);
        }
export function useGetSpecialtiesByWorkspaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables>(GetSpecialtiesByWorkspaceIdDocument, options);
        }
export type GetSpecialtiesByWorkspaceIdQueryHookResult = ReturnType<typeof useGetSpecialtiesByWorkspaceIdQuery>;
export type GetSpecialtiesByWorkspaceIdLazyQueryHookResult = ReturnType<typeof useGetSpecialtiesByWorkspaceIdLazyQuery>;
export type GetSpecialtiesByWorkspaceIdSuspenseQueryHookResult = ReturnType<typeof useGetSpecialtiesByWorkspaceIdSuspenseQuery>;
export type GetSpecialtiesByWorkspaceIdQueryResult = Apollo.QueryResult<GetSpecialtiesByWorkspaceIdQuery, GetSpecialtiesByWorkspaceIdQueryVariables>;